import { Col, Row } from "react-grid-system";
import {
  Container,
  InnerContainer,
  Wrapper,
} from "../../../../components/molecules/v2/TimelineSection/TimelineSection.styled";
import { func } from "../../../../utils";
import useWindowSize from "../../../../hooks/useWindowSize";
import { useNavigate } from "react-router-dom";

const GuestStarsV2 = ({ guestWording, KV, mobileKV, videoUrl }) => {
  const { size } = useWindowSize();
  const navigate = useNavigate();
  const isMobileView = (size?.width || 0) <= 768;

  const ButtonComponent = ({ children, title, type = "primary", onClick }) => {
    const getColor =
      type === "primary"
        ? {
            background: "bg-cyan-500",
            hoverBg: "hover:bg-cyan-600",
            bgIcon: "#0397C9",
          }
        : {
            background: "bg-[#AF183C]",
            hoverBg: "hover:bg-[#AF183C95]",
            bgIcon: "#7A112A",
          };
    return (
      <button
        onClick={onClick}
        className={`flex items-center ${getColor?.background} ${getColor?.hoverBg} bg-re text-white font-bold pr-4 pl-0 rounded-full shadow-lg border-none md:min-w-[277px] min-w-[234px] h-[48px] md:h-auto`}
      >
        <svg
          width={isMobileView ? "56" : "88"}
          height="72"
          viewBox="0 0 88 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="overflow-hidden"
        >
          <path
            d="M0 36C0 16.1178 16.1178 0 36 0H88V32C88 54.0914 70.0914 72 48 72H36C16.1178 72 0 55.8823 0 36Z"
            fill={getColor?.bgIcon}
          />
        </svg>

        {children}

        <span className="mx-6">{title}</span>
      </button>
    );
  };
  return (
    <div
      id="guest-star"
      className=" text-white bg-src !bg-none flex justify-center items-center"
    >
      <InnerContainer className="!max-w-max md:!py-[17svh] !pt-[10svh] !pb-[17svh]">
        <Wrapper>
          <Row
            gutterWidth={86}
            className={isMobileView ? "!flex-col-reverse" : ""}
          >
            <Col md={7} sm={12} className="md:mt-0 mt-8">
              <div className="md:mb-6">
                <h1 className="md:whitespace-pre whitespace-normal md:text-[50px] text-[24px] md:leading-[55px] leading-[34px] font-black md:!text-left text-center md:mb-0 mb-2">{`Sing-Along bareng
FAKEDOPP`}</h1>
                <p className="md:leading-[40px] leading-[22px] md:text-[20px] text-[14px] max-w-[463px] md:!text-left text-center">
                  {/* {guestWording} */}
                  {
                    "Sebagai penanda berakhirnya kompetisi Piala by.U 2025! Selebrasi akhir ini, bakal seru-seruan bareng FakeDop feat. Sintya Marisca plus Ammar & Barock! Ikuti terus info updatenya & jangan sampe ketinggalan!"
                  }
                </p>
              </div>
              <div className="flex md:gap-6 gap-3 md:mt-[50px] mt-[20px] items-center justify-center">
                <img
                  onClick={() => {
                    navigate("/soc/jadwal-pertandingan");
                  }}
                  className="md:max-h-[73px] max-h-[41px] cursor-pointer"
                  src={func.getStaticImg(
                    "illustration/conference/v2/guess-livestreaming-btn-red.png"
                  )}
                  alt="live-streaming"
                />
                <img
                  onClick={() => {
                    navigate("/soc/info-lokasi");
                  }}
                  className="md:max-h-[73px] max-h-[41px] cursor-pointer"
                  src={func.getStaticImg(
                    "illustration/conference/v2/guess-livestreaming-btn-white.png"
                  )}
                  alt="live-streaming"
                />
              </div>
            </Col>
            <Col md={5} sm={12} className="justify-center flex md:-mt-20">
              <img
                src={isMobileView ? mobileKV : KV}
                className="md:max-w-[452px] max-w-auto  mt-0"
                alt="guest-star"
              />
            </Col>
          </Row>
        </Wrapper>
      </InnerContainer>
    </div>
  );
};

export default GuestStarsV2;
